import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowLeft } from 'lucide-react';
import { popNavigation } from '../redux/slices/navigationSlice';

const BackButton = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Get navigation stack from Redux
  const { navigationStack } = useSelector(state => state.navigation);
  
  // Determine if back button should show and where to go
  let shouldShow = false;
  let targetRoute = null;
  let buttonText = '';
  
  // Check the navigation stack to find where we came from
  if (navigationStack.length > 0) {
    const lastNavigation = navigationStack[0];
    const fromRoute_ = lastNavigation.from;
    
    shouldShow = true;
    targetRoute = fromRoute_;
    
    // Set button text based on where we came from
    if (fromRoute_ === '/managing-director') {
      buttonText = 'Back to MD Dashboard';
    } else if (fromRoute_ === '/gmdashboard') {
      buttonText = 'Back to GM Dashboard';
    } else if (fromRoute_ === '/purchase') {
      buttonText = 'Back to Purchase Dashboard';
    } else if (fromRoute_ === '/pmdashboard') {
      buttonText = 'Back to Production Dashboard';
    } else if (fromRoute_ === '/sales') {
      buttonText = 'Back to Sales Dashboard';
    } else if (fromRoute_ === '/store-dashboard') {
      buttonText = 'Back to Store Dashboard';
    } else if (fromRoute_ === '/supervisor-dashboard') {
      buttonText = 'Back to Supervisor Dashboard';
    } else if (fromRoute_ === '/hr-dashboard') {
      buttonText = 'Back to HR Dashboard';
    } else if (fromRoute_ === '/employee-dashboard') {
      buttonText = 'Back to Employee Dashboard';
    } else {
      buttonText = 'Back';
    }
  }
  
  const handleBack = () => {
    if (targetRoute) {
      // Remove the last navigation from stack before navigating
      dispatch(popNavigation());
      navigate(targetRoute);
    }
  };
  
  if (!shouldShow) return null;
  
  return (
    <div style={{ margin: '20px 20px 0 20px' }}>
      <button
        onClick={handleBack}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '20px',
          padding: '10px 20px',
          background: 'linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '600',
          transition: 'all 0.3s ease',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateX(-3px)';
          e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateX(0)';
          e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
        }}
      >
        <ArrowLeft size={18} />
        {buttonText}
      </button>
    </div>
  );
};

export default BackButton;